import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, ChevronRight, ChevronLeft, Check, Flame, Loader2, BookOpen, List } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';
import api from '../../utils/api';

export default function ForgeStoryReader() {
  const navigate = useNavigate();
  const { languageCode, episode: episodeParam } = useParams();
  const episodeNum = parseInt(episodeParam);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    importAndOpenInReader();
  }, [languageCode, episodeNum]);

  const importAndOpenInReader = async () => {
    setLoading(true);
    try {
      // Import the episode as a reader text
      const resp = await api.post(`/forge-stories/episode/${languageCode}/${episodeNum}/import-to-reader`);
      const textId = resp.data.text_id;
      // Redirect to the Reader with forge story context
      navigate(`/reader/${textId}?from=forge-story&episode=${episodeNum}&lang=${languageCode}`, { replace: true });
    } catch (err) {
      console.error('Failed to import episode:', err);
      toast.error('Failed to open episode in reader');
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center space-y-3">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-500 mx-auto" />
        <p className="text-sm text-muted-foreground">Opening Episode {episodeNum} in Reader...</p>
      </div>
    </div>
  );
}
